<div fxLayout="column">
    <p-table #table [columns]="allColumns" [value]="tableData" dataKey="index" fxFlex="1 1 auto" selectionMode="multiple"
        scrollable="false" class="cash-flow-table" [paginator]="true" paginatorPosition="top" [rows]="rowsPerPage"
        sortMode="multiple" [loading]="loading" scrollHeight="70vh">
        <!--  (onRowSelect)="onRowSelect($event)" (onRowUnselect)="onRowUnselect($event)" -->
        <ng-template pTemplate="colgroup" let-columns>
            <colgroup>
                <col *ngFor="let col of columns" [style.width]="col.width">
            </colgroup>
        </ng-template>
        <ng-template pTemplate="header" let-columns>
            <tr>
                <ng-template ngFor let-col [ngForOf]="columns">
                    <th *ngIf="col.sortable">
                        <span class='cash-flow-field-header' [pSortableColumn]="col.field">{{col.header}}</span>
                        <p-sortIcon [field]="col.field"></p-sortIcon>
                    </th>
                    <th *ngIf="!col.sortable">
                        <span class='cash-flow-field-header'>{{col.header}}</span>
                    </th>
                </ng-template>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns">
            <tr [pSelectableRow]="rowData">
                <td *ngFor="let col of columns" [ngClass]="['text-center']" [pEditableColumn]="col.editable">
                    <span *ngIf="col.type === 'string'" class='cash-flow-field'>
                        {{rowData[col.field]}}
                    </span>
                    <span *ngIf="col.type === 'number'" class='cash-flow-field'>
                        {{rowData[col.field] | number:'1.2-5'}}
                    </span>
                    <span *ngIf="col.type === 'datetime'" class='cash-flow-field'>
                        {{rowData[col.field] | moment:'L'}} {{rowData[col.field] | moment:'LTS'}}
                    </span>
                    <span *ngIf="col.type === 'date'" class='cash-flow-field'>
                        {{rowData[col.field] | moment:'L'}}
                    </span>
                    <span *ngIf="col.type === 'amount'" class='cash-flow-field'>
                        {{rowData[col.field] | currencyrounding:3:rowData.currency:true | negativeparentheses}}
                    </span>
                    <span *ngIf="col.type === 'icon'" [class]="rowData.iconClass" [matTooltip]="rowData.cash-flowType"></span>
                    <span *ngIf="col.type === 'show'" class="fa fa-file-o" (click)="showcash-flow($event, rowData, cash-flowOverlay)"></span>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>